import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { FaDna } from 'react-icons/fa6';
import BiologiaMolecularForm from '../components/BiologiaMolecularForm';
import { normalizeAssayId } from '../utils/biologiaMolecular';

const BM_DEBUG_PREFIX = '[BM DEBUG]';

const BiologiaMolecularPage = ({ mode = 'workflow' }) => {
  const { ensayoNumero } = useParams();
  const location = useLocation();
  const normalizedAssayId = normalizeAssayId(ensayoNumero);
  const isEditMode = Boolean(normalizedAssayId);
  const isClosureMode = mode === 'closure';
  const protocoloGeneralInicial = location.state?.protocoloGeneral || '';
  const protocoloMuestraInicial = location.state?.protocoloMuestra || '';

  useEffect(() => {
    console.log(BM_DEBUG_PREFIX, 'BiologiaMolecularPage renderizo con este contexto', {
      ensayoNumero,
      isClosureMode,
      isEditMode,
      mode,
      normalizedAssayId,
      pathname: location.pathname,
      state: location.state,
    });
  }, [ensayoNumero, isClosureMode, isEditMode, location.pathname, location.state, mode, normalizedAssayId]);

  return (
    <section className="container page-shell">
      <div className="page-header">
        <div>
          <span className="section-kicker">
            {isClosureMode ? 'Cierre' : isEditMode ? 'Edicion' : 'Sector'}
          </span>
          <h2 className="page-title">
            {isClosureMode
              ? 'Cierre y validacion del ensayo'
              : isEditMode
                ? 'Editar ensayo de biologia molecular'
                : 'Biologia molecular'}
          </h2>
          <p className="page-subtitle">
            {isClosureMode
              ? 'Completa la conformidad final, la validacion y los adjuntos del ensayo molecular ya registrado.'
              : isEditMode
                ? 'Actualiza la corrida PCR/RT-PCR y guarda los cambios del ensayo.'
                : 'Registra un ensayo molecular en 3 pasos para mantener trazabilidad del protocolo, reactivos y corrida.'}
          </p>
        </div>
        <div className="molecular-page-badge" aria-hidden="true">
          <FaDna />
        </div>
      </div>

      <BiologiaMolecularForm
        assayId={normalizedAssayId}
        protocoloGeneralInicial={protocoloGeneralInicial}
        protocoloMuestraInicial={protocoloMuestraInicial}
        viewMode={mode}
      />
    </section>
  );
};

export default BiologiaMolecularPage;
